import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTopVote = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "#545E6B",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 10.4722C0.772501 9.37357 0 7.777 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.777 11.2275 9.37357 10 10.4722V16L6 14L2 16V10.4722ZM6 7.80426L8.47214 9L8 6.46738L10 4.67376L7.23607 4.30426L6 2L4.76393 4.30426L2 4.67376L4 6.46738L3.52786 9L6 7.80426Z"
	})]
});
const ForwardRef = forwardRef(SvgTopVote);
export { ForwardRef as ReactComponent };
